<div class="warehouse_container">
    <div class="background_warehouse">
      <div class="layer" [style.width.%]="100 - percentageValue" [class]="classPercentage">
        <div class="overlayimage">
          <div class="percentage">
            {{ percentageValue }}%
          </div>
        </div>
      </div>
    </div>
    </div>
    